<template>
  <el-row :class="$style.main">
    <el-col :span="14">
      <el-form ref="form" :model="form" :rules="rules" size="mini" label-width="180px" v-if="inited">
        <el-form-item label="归属中心" prop="branch">
          <el-select v-model="form.branch" placeholder="请选择归属中心">
            <el-option v-for="item in branchList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="关联直播室ID" prop="room_id">
          <el-input v-model="form.room_id"></el-input>
        </el-form-item>
        <el-form-item required label="企业微信主体标签ID对应" :error="errorMsg" :inline-message="true"> </el-form-item>
        <el-form-item class="left"  v-for="item in corps" :key="item.crop_id" :label="item.corp_name" label-width="320px">
          <el-input v-model="item.tag_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" :disabled="!canSubmit" @click="onSave">{{
            isEditMode ? "保存" : "新增"
          }}</el-button>
          <el-button size="mini" @click="onBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { getServiceInfo, postUpdateService } from "./api";
import { getBranchList } from "@/modules/departments";
// import { formIndex } from "./../../mixin/formIndex";

export default {
  name: "WxWorkService",
  components: {},
  data() {
    const isEditMode = !!this.$route.query.info;
    const branchList = getBranchList();
    return {
      isEditMode,
      inited: false,
      info: {},
      branchList,
      form: {
        branch: "",
        name: "",
        room_id: "",
      },
      corps: [],
      rules: {
        branch: [{ required: true, message: "请选择归属中心", trigger: "change" }],
        name: [{ required: true, message: "请输入服务名称", trigger: "blur" }],
        room_id: [{ required: true, message: "请输入直播室ID", trigger: "blur" }],
      },
    };
  },
  computed: {
    errorMsg() {
      return this.corps.find((item) => item.tag_id) ? "" : "下面的关联标签ID至少填写一个";
    },
    canSubmit() {
      const form = this.form;
      return form.branch && form.name && form.room_id && !this.errorMsg;
    },
  },
  created() {
    if (this.isEditMode) {
      this.info = JSON.parse(this.$route.query.info);
    }
    this.handleGetServiceInfo();
  },
  mounted() {},
  methods: {
    async handleGetServiceInfo() {
      const { branch, room_id } = this.info;
      const res = await getServiceInfo({ branch, room_id });
      const {
        code,
        msg,
        data: { crops, ...data },
      } = await res.json();
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      if (data.branch == 0) data.branch = "";
      if (data.room_id == 0) data.room_id = "";
      this.form = data;
      this.corps = crops.map((item) => {
        if (!item.tag_id) {
          item.tag_id = "";
        }
        return item;
      });
      this.inited = true;
    },
    handleEdit() {
      this.isEditing = true;
    },
    async onSave() {
      const { branch, room_id, name } = this.form;
      const crops = this.corps.map((i) => {
        return { id: i.id, tag_id: i.tag_id || 0, corp_id: i.crop_id };
      });
      let params = { branch, room_id, name, crops }
      const res = await postUpdateService(params);
      const { code, msg } = await res.json();
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.onBack();
    },
    onBack() {
      // this.$router.back();
      import("@/modules/headBack/headBack").then(({ Back }) => {
        Back()
      })
    },
  },
};
</script>

<style lang="scss" module>
.main{
  background: #fff;
  padding: 20px;
}
</style>
<style lang="scss">
.left  {
  .el-form-item__label{
    padding-left: 180px;
    text-align: left !important;
  }
}
</style>
